// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"44de3ff9","488":"78e00a6f"}[chunkId] + ".chunk.js";
};